import { Link } from 'react-router-dom'

const FeaturedWork = () => {
    const featuredItems = [
        {
            icon: "fas fa-building",
            title: "Dekraiol - dekraiol.co.za",
            description: "Professional services platform with modern responsive design, CMS integration, and comprehensive service showcase.",
            link: 'https://dekraiol.co.za',
            image: '/images/screenshots/Dekraiol.co.za.png'
        },
        {
            icon: "fas fa-wordpress",
            title: "Sports Legacy Company - WordPress",
            description: "Custom WordPress theme for B-BBEE compliance and sports development company with dynamic features and modern design.",
            link: 'https://sportlegacycompany.co.za/',
            image: '/images/screenshots/slc-demo.png'
        }
    ]

    return (
        <section className="section featured-work">
            <div className="section-inner">
                <h2 className="title title-h2">Featured<br />Work</h2>
                <h3 className="subtitle subtitle-h3">Recent Projects</h3>
                <p className="description">
                    Selected projects showcasing our expertise in design, development, and strategy.
                </p>
                <div className="featured-grid">
                    {featuredItems.map((item, index) => (
                        <div className="featured-item" key={index}>
                            <div className="featured-image">
                                {item.image ? (
                                    <img 
                                        src={item.image} 
                                        alt={item.title}
                                        loading="lazy"
                                        decoding="async"
                                        style={{ 
                                            width: '100%', 
                                            height: '100%', 
                                            objectFit: 'contain', 
                                            borderRadius: '8px' 
                                        }}
                                        onError={(e) => {
                                            e.target.style.display = 'none'
                                            e.target.nextElementSibling.style.display = 'flex'
                                        }}
                                    />
                                ) : null}
                                <div style={{
                                    width: "100%",
                                    height: "100%",
                                    background: "linear-gradient(45deg, var(--color-quaternary), var(--color-primary))",
                                    display: item.image ? "none" : "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    borderRadius: "8px"
                                }}>
                                    <i className={item.icon} style={{
                                        fontSize: "3rem",
                                        color: "var(--color-text)"
                                    }}></i>
                                </div>
                            </div>
                            <h3>{item.title}</h3>
                            <p>{item.description}</p>
                            <div style={{ display: 'flex', gap: 'var(--space-3)', flexWrap: 'wrap' }}>
                                <a className="btn btn-secondary" href={item.link} target="_blank" rel="noopener noreferrer">View Live Site</a>
                            </div>
                        </div>
                    ))}
                </div>
                
                <div style={{ textAlign: 'center', marginTop: 'var(--space-8)' }}>
                    <Link to="/portfolio" className="btn btn-primary" style={{ display: 'inline-block' }}>
                        View All Work
                    </Link>
                </div>
            </div>
        </section>
    )
}

export default FeaturedWork
